import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { getIconBrandPrefix } from '../../shared/icon-brand-prefix';

@Component({
  selector: 'app-register-pass-key-prompt',
  templateUrl: './register-pass-key-prompt.component.html',
  styleUrl: './register-pass-key-prompt.component.scss',
  standalone: false
})
export class RegisterPassKeyPromptComponent implements OnInit {

  onCreatePasskeySubmit: () => void;
  onPasskeySkipSubmit: () => void;
  onPasskeyDeclineSubmit: () => void;
  client;
  iconPrefix: string;
  createPasskey;

  constructor(private readonly translate: TranslateService,
    private readonly cookieService: CookieService
  ){}

  ngOnInit(): void {
    this.client  = this.cookieService.get('client');
    this.iconPrefix = getIconBrandPrefix(this.client);

    if (this.client === 'shaw'){
      this.createPasskey = 'passkey.shaw.createPasskey'
    }
    else if (this.client === 'shaw_direct'){
      this.createPasskey = 'passkey.shawDirect.createPasskey'
    }
    else if (this.client === 'shaw_enterprise'){
      this.createPasskey = 'passkey.shawEnterprise.createPasskey'
    }
    else{
      this.createPasskey = 'passkey.register.createPasskey'
    }
    if (this.client === 'media' || this.client === 'r4b'){
      this.createPasskey = 'passkey.register.createPasskeyProfile'
    }
  }


  onCreatePasskeyClick(){
    this.onCreatePasskeySubmit();
  }

  onSkipPasskeyClick(){
    this.onPasskeySkipSubmit();
  }

  onPasskeyDeclineClick(){
    this.onPasskeyDeclineSubmit();
  }
}
